const { isEqual } = require("lodash-es");

export function areAllSetsEqual(setList) {
  // Check if all sets are equal
  const firstSet = setList[0];
  for (let i = 1; i < setList.length; i++) {
    if (!isEqual(firstSet, setList[i])) {
      return false;
    }
  }
  return true;
}
